import type { ISettingsMenuIcon } from './helpers';

export const SettingsMenuIcon = ({ variant, ...rest }: ISettingsMenuIcon) => {
	if (variant === 'profile')
		return (
			<svg
				width='40'
				height='40'
				viewBox='0 0 40 32'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g filter='url(#filter0_d_4910_123576)'>
					<circle
						cx='20'
						cy='16.5312'
						r='16'
						fill='#E4ECFB'
					/>
					<path
						opacity='0.4'
						d='M26.2463 16.1242V20.1175C26.2463 21.9575 24.7529 23.4508 22.9129 23.4508H17.0863C15.2463 23.4508 13.7529 21.9575 13.7529 20.1175V16.1708C14.2596 16.7175 14.9796 17.0308 15.7596 17.0308C16.5996 17.0308 17.4063 16.6108 17.9129 15.9375C18.3663 16.6108 19.1396 17.0308 19.9996 17.0308C20.8529 17.0308 21.6129 16.6308 22.0729 15.9642C22.5863 16.6242 23.3796 17.0308 24.2063 17.0308C25.0129 17.0308 25.7463 16.7042 26.2463 16.1242Z'
						fill='#566F83'
					/>
					<path
						d='M21.542 9.86426L22.0137 14.4795V14.5742C22.0083 14.8481 21.9494 15.1166 21.8555 15.3438C21.5374 16.0698 20.8344 16.5311 20.001 16.5312C19.1806 16.5312 18.4596 16.0571 18.1543 15.3418L18.1533 15.3398L18.1074 15.2236C18.0087 14.9477 17.97 14.6434 17.999 14.3145L17.998 14.3135L18.4463 9.86426H21.542Z'
						fill='#566F83'
						stroke='#566F83'
					/>
					<path
						opacity='0.6'
						d='M26.9068 14.0443L26.7135 12.1976C26.4335 10.1843 25.5202 9.36426 23.5668 9.36426H21.0068L21.5002 14.3643C21.5068 14.4309 21.5135 14.5043 21.5135 14.6309C21.5535 14.9776 21.6602 15.2976 21.8202 15.5843C22.3002 16.4643 23.2335 17.0309 24.2068 17.0309C25.0935 17.0309 25.8935 16.6376 26.3935 15.9443C26.7935 15.4109 26.9735 14.7376 26.9068 14.0443Z'
						fill='#566F83'
					/>
					<path
						opacity='0.6'
						d='M16.3931 9.36426C14.4331 9.36426 13.5264 10.1843 13.2398 12.2176L13.0598 14.0509C12.9931 14.7643 13.1864 15.4576 13.6064 15.9976C14.1131 16.6576 14.8931 17.0309 15.7598 17.0309C16.7331 17.0309 17.6664 16.4643 18.1398 15.5976C18.3131 15.2976 18.4264 14.9509 18.4598 14.5909L18.9798 9.37092H16.3931V9.36426Z'
						fill='#566F83'
					/>
					<path
						d='M19.5667 19.6378C18.7201 19.7244 18.0801 20.4444 18.0801 21.2978V23.4511H21.9134V21.5311C21.9201 20.1378 21.1001 19.4778 19.5667 19.6378Z'
						fill='#566F83'
					/>
				</g>
				<defs>
					<filter
						id='filter0_d_4910_123576'
						x='0'
						y='0.53125'
						width='40'
						height='40'
						filterUnits='userSpaceOnUse'
						colorInterpolationFilters='sRGB'
					>
						<feFlood
							floodOpacity='0'
							result='BackgroundImageFix'
						/>
						<feColorMatrix
							in='SourceAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
							result='hardAlpha'
						/>
						<feOffset dy='4' />
						<feGaussianBlur stdDeviation='2' />
						<feComposite
							in2='hardAlpha'
							operator='out'
						/>
						<feColorMatrix
							type='matrix'
							values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0'
						/>
						<feBlend
							mode='normal'
							in2='BackgroundImageFix'
							result='effect1_dropShadow_4910_123576'
						/>
						<feBlend
							mode='normal'
							in='SourceGraphic'
							in2='effect1_dropShadow_4910_123576'
							result='shape'
						/>
					</filter>
				</defs>
			</svg>
		);

	if (variant === 'security')
		return (
			<svg
				width='40'
				height='40'
				viewBox='0 0 40 32'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g filter='url(#filter0_d_4910_123585)'>
					<circle
						cx='20'
						cy='16.5312'
						r='16'
						fill='#E4ECFB'
					/>
					<path
						d='M24.5 13.8643V15.2643C24.2067 15.2243 23.8733 15.2043 23.5 15.1976V13.8643C23.5 11.7643 22.9067 10.3643 20 10.3643C17.0933 10.3643 16.5 11.7643 16.5 13.8643V15.1976C16.1267 15.2043 15.7933 15.2243 15.5 15.2643V13.8643C15.5 11.9309 15.9667 9.36426 20 9.36426C24.0333 9.36426 24.5 11.9309 24.5 13.8643Z'
						fill='#022745'
					/>
					<path
						opacity='0.4'
						d='M26.6663 18.5316V19.8649C26.6663 22.5316 25.9997 23.1982 23.333 23.1982H16.6663C13.9997 23.1982 13.333 22.5316 13.333 19.8649V18.5316C13.333 16.3049 13.7997 15.4716 15.4997 15.2649C15.793 15.2249 16.1263 15.2049 16.4997 15.1982H23.4997C23.873 15.2049 24.2063 15.2249 24.4997 15.2649C26.1997 15.4716 26.6663 16.3049 26.6663 18.5316Z'
						fill='#022745'
					/>
					<path
						d='M17.3337 19.8648C17.247 19.8648 17.1603 19.8448 17.0803 19.8115C16.9937 19.7782 16.927 19.7315 16.8603 19.6715C16.7403 19.5448 16.667 19.3715 16.667 19.1982C16.667 19.1115 16.687 19.0248 16.7203 18.9448C16.7536 18.8648 16.8003 18.7915 16.8603 18.7248C16.927 18.6648 16.9937 18.6182 17.0803 18.5848C17.327 18.4782 17.6203 18.5381 17.807 18.7248C17.867 18.7915 17.9137 18.8648 17.947 18.9448C17.9803 19.0248 18.0003 19.1115 18.0003 19.1982C18.0003 19.3715 17.927 19.5448 17.807 19.6715C17.6803 19.7915 17.507 19.8648 17.3337 19.8648Z'
						fill='#022745'
					/>
					<path
						d='M19.9997 19.865C19.8197 19.865 19.653 19.7917 19.5263 19.6717C19.4663 19.605 19.4197 19.5317 19.3863 19.4517C19.353 19.3717 19.333 19.285 19.333 19.1984C19.333 19.0184 19.4063 18.8517 19.5263 18.725C19.773 18.4784 20.2197 18.4784 20.473 18.725C20.593 18.8517 20.6663 19.0184 20.6663 19.1984C20.6663 19.285 20.6464 19.3717 20.613 19.4517C20.5797 19.5317 20.533 19.605 20.473 19.6717C20.3463 19.7917 20.173 19.865 19.9997 19.865Z'
						fill='#022745'
					/>
					<path
						d='M22.6667 19.865C22.4933 19.865 22.32 19.7917 22.1933 19.6717C22.0733 19.545 22 19.3784 22 19.1984C22 19.0184 22.0733 18.8517 22.1933 18.725C22.4467 18.4784 22.8933 18.4784 23.14 18.725C23.1667 18.7584 23.1933 18.7917 23.22 18.8317C23.2467 18.865 23.2667 18.905 23.28 18.945C23.3 18.985 23.3133 19.025 23.32 19.065C23.3267 19.1117 23.3333 19.1584 23.3333 19.1984C23.3333 19.3717 23.26 19.545 23.14 19.6717C23.0133 19.7917 22.84 19.865 22.6667 19.865Z'
						fill='#022745'
					/>
				</g>
				<defs>
					<filter
						id='filter0_d_4910_123585'
						x='0'
						y='0.53125'
						width='40'
						height='40'
						filterUnits='userSpaceOnUse'
						colorInterpolationFilters='sRGB'
					>
						<feFlood
							floodOpacity='0'
							result='BackgroundImageFix'
						/>
						<feColorMatrix
							in='SourceAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
							result='hardAlpha'
						/>
						<feOffset dy='4' />
						<feGaussianBlur stdDeviation='2' />
						<feComposite
							in2='hardAlpha'
							operator='out'
						/>
						<feColorMatrix
							type='matrix'
							values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0'
						/>
						<feBlend
							mode='normal'
							in2='BackgroundImageFix'
							result='effect1_dropShadow_4910_123585'
						/>
						<feBlend
							mode='normal'
							in='SourceGraphic'
							in2='effect1_dropShadow_4910_123585'
							result='shape'
						/>
					</filter>
				</defs>
			</svg>
		);

	if (variant === 'authenticator')
		return (
			<svg
				width='48'
				height='48'
				viewBox='0 0 48 48'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g filter='url(#filter0_d_11599_149945)'>
					<circle
						cx='24'
						cy='20'
						r='20'
						fill='#E4ECFB'
					/>
					<path
						d='M29.2752 14.7263L19.4919 24.5096C19.1252 24.8763 18.5086 24.8263 18.2086 24.3929C17.1752 22.8846 16.5669 21.1013 16.5669 19.268V15.6096C16.5669 14.9263 17.0836 14.1513 17.7169 13.893L22.3586 11.993C23.4086 11.5596 24.5752 11.5596 25.6252 11.993L28.9919 13.368C29.5502 13.593 29.6919 14.3096 29.2752 14.7263Z'
						fill='#022745'
					/>
					<path
						opacity='0.4'
						d='M30.0582 15.8654C30.5998 15.4071 31.4249 15.7987 31.4249 16.507V19.2654C31.4249 23.3404 28.4665 27.157 24.4249 28.2737C24.1499 28.3487 23.8499 28.3487 23.5665 28.2737C22.3832 27.9404 21.2832 27.3821 20.3415 26.6487C19.9415 26.3404 19.8998 25.7571 20.2498 25.3987C22.0665 23.5404 27.3832 18.1237 30.0582 15.8654Z'
						fill='#022745'
					/>
				</g>
				<defs>
					<filter
						id='filter0_d_11599_149945'
						x='0'
						y='0'
						width='48'
						height='48'
						filterUnits='userSpaceOnUse'
						colorInterpolationFilters='sRGB'
					>
						<feFlood
							floodOpacity='0'
							result='BackgroundImageFix'
						/>
						<feColorMatrix
							in='SourceAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
							result='hardAlpha'
						/>
						<feOffset dy='4' />
						<feGaussianBlur stdDeviation='2' />
						<feComposite
							in2='hardAlpha'
							operator='out'
						/>
						<feColorMatrix
							type='matrix'
							values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0'
						/>
						<feBlend
							mode='normal'
							in2='BackgroundImageFix'
							result='effect1_dropShadow_11599_149945'
						/>
						<feBlend
							mode='normal'
							in='SourceGraphic'
							in2='effect1_dropShadow_11599_149945'
							result='shape'
						/>
					</filter>
				</defs>
			</svg>
		);

	if (variant === 'email2fa')
		return (
			<svg
				width='48'
				height='48'
				viewBox='0 0 48 48'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g filter='url(#filter0_d_11599_149958)'>
					<circle
						cx='24'
						cy='20'
						r='20'
						fill='#E4ECFB'
					/>
					<path
						d='M29.625 16.668V18.418C29.2583 18.368 28.8417 18.343 28.375 18.3346V16.668C28.375 14.043 27.6333 12.293 24 12.293C20.3667 12.293 19.625 14.043 19.625 16.668V18.3346C19.1583 18.343 18.7417 18.368 18.375 18.418V16.668C18.375 14.2513 18.9583 11.043 24 11.043C29.0417 11.043 29.625 14.2513 29.625 16.668Z'
						fill='#1F3D6A'
					/>
					<path
						opacity='0.4'
						d='M32.3332 22.4987V24.1654C32.3332 27.4987 31.4998 28.332 28.1665 28.332H19.8332C16.4998 28.332 15.6665 27.4987 15.6665 24.1654V22.4987C15.6665 19.7154 16.2498 18.6737 18.3748 18.4154C18.7415 18.3654 19.1582 18.3404 19.6248 18.332H28.3748C28.8415 18.3404 29.2582 18.3654 29.6248 18.4154C31.7498 18.6737 32.3332 19.7154 32.3332 22.4987Z'
						fill='#1F3D6A'
					/>
					<path
						d='M20.6668 24.1657C20.5585 24.1657 20.4502 24.1407 20.3502 24.0991C20.2418 24.0574 20.1585 23.9991 20.0752 23.9241C19.9252 23.7657 19.8335 23.5491 19.8335 23.3324C19.8335 23.2241 19.8585 23.1157 19.9002 23.0157C19.9418 22.9157 20.0002 22.8241 20.0752 22.7407C20.1585 22.6657 20.2418 22.6074 20.3502 22.5657C20.6585 22.4324 21.0252 22.5074 21.2585 22.7407C21.3335 22.8241 21.3918 22.9157 21.4335 23.0157C21.4752 23.1157 21.5002 23.2241 21.5002 23.3324C21.5002 23.5491 21.4085 23.7657 21.2585 23.9241C21.1002 24.0741 20.8835 24.1657 20.6668 24.1657Z'
						fill='#292D32'
					/>
					<path
						d='M23.9998 24.168C23.7748 24.168 23.5665 24.0763 23.4082 23.9263C23.3332 23.843 23.2748 23.7513 23.2332 23.6513C23.1915 23.5513 23.1665 23.443 23.1665 23.3346C23.1665 23.1096 23.2582 22.9013 23.4082 22.743C23.7165 22.4346 24.2748 22.4346 24.5915 22.743C24.7415 22.9013 24.8332 23.1096 24.8332 23.3346C24.8332 23.443 24.8082 23.5513 24.7665 23.6513C24.7248 23.7513 24.6665 23.843 24.5915 23.9263C24.4332 24.0763 24.2165 24.168 23.9998 24.168Z'
						fill='#292D32'
					/>
					<path
						d='M27.3333 24.168C27.1167 24.168 26.9 24.0763 26.7417 23.9263C26.5917 23.768 26.5 23.5596 26.5 23.3346C26.5 23.1096 26.5917 22.9013 26.7417 22.743C27.0583 22.4346 27.6167 22.4346 27.925 22.743C27.9583 22.7846 27.9917 22.8263 28.025 22.8763C28.0583 22.918 28.0833 22.968 28.1 23.018C28.125 23.068 28.1417 23.118 28.15 23.168C28.1583 23.2263 28.1667 23.2846 28.1667 23.3346C28.1667 23.5513 28.075 23.768 27.925 23.9263C27.7667 24.0763 27.55 24.168 27.3333 24.168Z'
						fill='#292D32'
					/>
				</g>
				<defs>
					<filter
						id='filter0_d_11599_149958'
						x='0'
						y='0'
						width='48'
						height='48'
						filterUnits='userSpaceOnUse'
						colorInterpolationFilters='sRGB'
					>
						<feFlood
							floodOpacity='0'
							result='BackgroundImageFix'
						/>
						<feColorMatrix
							in='SourceAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
							result='hardAlpha'
						/>
						<feOffset dy='4' />
						<feGaussianBlur stdDeviation='2' />
						<feComposite
							in2='hardAlpha'
							operator='out'
						/>
						<feColorMatrix
							type='matrix'
							values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0'
						/>
						<feBlend
							mode='normal'
							in2='BackgroundImageFix'
							result='effect1_dropShadow_11599_149958'
						/>
						<feBlend
							mode='normal'
							in='SourceGraphic'
							in2='effect1_dropShadow_11599_149958'
							result='shape'
						/>
					</filter>
				</defs>
			</svg>
		);

	if (variant === 'change-password')
		return (
			<svg
				width='40'
				height='40'
				viewBox='0 0 40 32'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g filter='url(#filter0_d_11029_54367)'>
					<circle
						cx='20'
						cy='16'
						r='16'
						fill='#E4ECFB'
					/>
					<path
						d='M22 22.6673C21.7267 22.6673 21.5 22.4407 21.5 22.1673V9.83398C21.5 9.56065 21.7267 9.33398 22 9.33398C22.2733 9.33398 22.5 9.56065 22.5 9.83398V22.1673C22.5 22.4407 22.2733 22.6673 22 22.6673Z'
						fill='#022745'
					/>
					<path
						opacity='0.4'
						d='M16.3337 21.3327H20.3337V10.666H16.3337C14.8603 10.666 13.667 11.8593 13.667 13.3327V18.666C13.667 20.1393 14.8603 21.3327 16.3337 21.3327Z'
						fill='#022745'
					/>
					<path
						opacity='0.4'
						d='M24 21.3327H22V10.666H24C25.4733 10.666 26.6667 11.8593 26.6667 13.3327V18.666C26.6667 20.1393 25.4733 21.3327 24 21.3327Z'
						fill='#022745'
					/>
					<path
						d='M15.8337 16.666C15.747 16.666 15.6603 16.646 15.5803 16.6126C15.5003 16.5793 15.427 16.5326 15.3603 16.4726C15.3003 16.406 15.2537 16.3326 15.2137 16.2526C15.1803 16.1726 15.167 16.086 15.167 15.9993C15.167 15.826 15.2403 15.6526 15.3603 15.526C15.3937 15.4993 15.427 15.4726 15.4603 15.446C15.5003 15.4193 15.5403 15.3993 15.5803 15.386C15.6203 15.366 15.6603 15.3526 15.7003 15.346C15.927 15.2993 16.1537 15.3726 16.307 15.526C16.427 15.6526 16.5003 15.826 16.5003 15.9993C16.5003 16.086 16.4803 16.1726 16.447 16.2526C16.4137 16.3326 16.367 16.406 16.307 16.4726C16.2403 16.5326 16.167 16.5793 16.087 16.6126C16.007 16.646 15.9203 16.666 15.8337 16.666Z'
						fill='#022745'
					/>
					<path
						d='M18.1667 16.6668C18.08 16.6668 17.9933 16.6468 17.9133 16.6135C17.8333 16.5801 17.76 16.5335 17.6933 16.4735C17.5667 16.3468 17.5 16.1801 17.5 16.0001C17.5 15.9135 17.52 15.8268 17.5533 15.7468C17.5867 15.6601 17.6333 15.5935 17.6933 15.5268C17.94 15.2801 18.3867 15.2801 18.64 15.5268C18.76 15.6535 18.8333 15.8268 18.8333 16.0001C18.8333 16.0868 18.8133 16.1735 18.78 16.2535C18.7467 16.3335 18.7 16.4068 18.64 16.4735C18.5733 16.5335 18.5 16.5801 18.42 16.6135C18.34 16.6468 18.2533 16.6668 18.1667 16.6668Z'
						fill='#022745'
					/>
				</g>
				<defs>
					<filter
						id='filter0_d_11029_54367'
						x='0'
						y='0'
						width='40'
						height='40'
						filterUnits='userSpaceOnUse'
						colorInterpolationFilters='sRGB'
					>
						<feFlood
							floodOpacity='0'
							result='BackgroundImageFix'
						/>
						<feColorMatrix
							in='SourceAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
							result='hardAlpha'
						/>
						<feOffset dy='4' />
						<feGaussianBlur stdDeviation='2' />
						<feComposite
							in2='hardAlpha'
							operator='out'
						/>
						<feColorMatrix
							type='matrix'
							values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0'
						/>
						<feBlend
							mode='normal'
							in2='BackgroundImageFix'
							result='effect1_dropShadow_11029_54367'
						/>
						<feBlend
							mode='normal'
							in='SourceGraphic'
							in2='effect1_dropShadow_11029_54367'
							result='shape'
						/>
					</filter>
				</defs>
			</svg>
		);

	if (variant === 'auto-settlement')
		return (
			<svg
				width='40'
				height='40'
				viewBox='0 0 40 32'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g filter='url(#filter0_d_4910_123594)'>
					<circle
						cx='20'
						cy='16.5312'
						r='16'
						fill='#E4ECFB'
					/>
					<path
						d='M23.333 10.8643H16.6663C14.6663 10.8643 13.333 11.8643 13.333 14.1976V18.8643C13.333 21.1976 14.6663 22.1976 16.6663 22.1976H23.333C25.333 22.1976 26.6663 21.1976 26.6663 18.8643V14.1976C26.6663 11.8643 25.333 10.8643 23.333 10.8643ZM16.1663 18.1976C16.1663 18.4709 15.9397 18.6976 15.6663 18.6976C15.393 18.6976 15.1663 18.4709 15.1663 18.1976V14.8643C15.1663 14.5909 15.393 14.3643 15.6663 14.3643C15.9397 14.3643 16.1663 14.5909 16.1663 14.8643V18.1976ZM19.9997 18.5309C18.893 18.5309 17.9997 17.6376 17.9997 16.5309C17.9997 15.4243 18.893 14.5309 19.9997 14.5309C21.1063 14.5309 21.9997 15.4243 21.9997 16.5309C21.9997 17.6376 21.1063 18.5309 19.9997 18.5309ZM24.833 18.1976C24.833 18.4709 24.6063 18.6976 24.333 18.6976C24.0597 18.6976 23.833 18.4709 23.833 18.1976V14.8643C23.833 14.5909 24.0597 14.3643 24.333 14.3643C24.6063 14.3643 24.833 14.5909 24.833 14.8643V18.1976Z'
						fill='#8193A2'
					/>
				</g>
				<defs>
					<filter
						id='filter0_d_4910_123594'
						x='0'
						y='0.53125'
						width='40'
						height='40'
						filterUnits='userSpaceOnUse'
						colorInterpolationFilters='sRGB'
					>
						<feFlood
							floodOpacity='0'
							result='BackgroundImageFix'
						/>
						<feColorMatrix
							in='SourceAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
							result='hardAlpha'
						/>
						<feOffset dy='4' />
						<feGaussianBlur stdDeviation='2' />
						<feComposite
							in2='hardAlpha'
							operator='out'
						/>
						<feColorMatrix
							type='matrix'
							values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0'
						/>
						<feBlend
							mode='normal'
							in2='BackgroundImageFix'
							result='effect1_dropShadow_4910_123594'
						/>
						<feBlend
							mode='normal'
							in='SourceGraphic'
							in2='effect1_dropShadow_4910_123594'
							result='shape'
						/>
					</filter>
				</defs>
			</svg>
		);

	if (variant === 'refer-a-friend')
		return (
			<svg
				width='40'
				height='40'
				viewBox='0 0 40 32'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g filter='url(#filter0_d_6031_171893)'>
					<circle
						cx='20'
						cy='16.5312'
						r='16'
						fill='#E4ECFB'
					/>
					<path
						opacity='0.4'
						d='M26.0604 22.8643C26.0604 23.0509 25.9138 23.1976 25.7271 23.1976H14.2738C14.0871 23.1976 13.9404 23.0509 13.9404 22.8643C13.9404 20.1043 16.6604 17.8643 20.0004 17.8643C20.6871 17.8643 21.3538 17.9576 21.9671 18.1376C21.5738 18.6042 21.3338 19.2109 21.3338 19.8643C21.3338 20.3643 21.4738 20.8376 21.7204 21.2376C21.8538 21.4643 22.0271 21.6709 22.2271 21.8442C22.6938 22.2709 23.3138 22.5309 24.0004 22.5309C24.7471 22.5309 25.4204 22.2243 25.9004 21.7309C26.0071 22.0909 26.0604 22.4709 26.0604 22.8643Z'
						fill='#8193A2'
					/>
					<path
						d='M25.9797 18.0849C25.4997 17.5383 24.7863 17.1982 23.9997 17.1982C23.253 17.1982 22.573 17.5049 22.0863 18.0049C21.6197 18.4849 21.333 19.1449 21.333 19.8649C21.333 20.3649 21.473 20.8382 21.7197 21.2382C21.853 21.4649 22.0263 21.6716 22.2263 21.8449C22.693 22.2716 23.313 22.5316 23.9997 22.5316C24.973 22.5316 25.8197 22.0116 26.2797 21.2382C26.4197 21.0116 26.5263 20.7516 26.5863 20.4849C26.6397 20.2849 26.6663 20.0782 26.6663 19.8649C26.6663 19.1849 26.4063 18.5583 25.9797 18.0849ZM24.9997 20.3516H24.4997V20.8716C24.4997 21.1449 24.273 21.3716 23.9997 21.3716C23.7263 21.3716 23.4997 21.1449 23.4997 20.8716V20.3516H22.9997C22.7263 20.3516 22.4997 20.1249 22.4997 19.8516C22.4997 19.5782 22.7263 19.3516 22.9997 19.3516H23.4997V18.8783C23.4997 18.6049 23.7263 18.3783 23.9997 18.3783C24.273 18.3783 24.4997 18.6049 24.4997 18.8783V19.3516H24.9997C25.273 19.3516 25.4997 19.5782 25.4997 19.8516C25.4997 20.1249 25.273 20.3516 24.9997 20.3516Z'
						fill='#022745'
					/>
					<path
						d='M20.0003 16.5309C21.8413 16.5309 23.3337 15.0385 23.3337 13.1976C23.3337 11.3566 21.8413 9.86426 20.0003 9.86426C18.1594 9.86426 16.667 11.3566 16.667 13.1976C16.667 15.0385 18.1594 16.5309 20.0003 16.5309Z'
						fill='#022745'
					/>
				</g>
				<defs>
					<filter
						id='filter0_d_6031_171893'
						x='0'
						y='0.53125'
						width='40'
						height='40'
						filterUnits='userSpaceOnUse'
						colorInterpolationFilters='sRGB'
					>
						<feFlood
							floodOpacity='0'
							result='BackgroundImageFix'
						/>
						<feColorMatrix
							in='SourceAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
							result='hardAlpha'
						/>
						<feOffset dy='4' />
						<feGaussianBlur stdDeviation='2' />
						<feComposite
							in2='hardAlpha'
							operator='out'
						/>
						<feColorMatrix
							type='matrix'
							values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0'
						/>
						<feBlend
							mode='normal'
							in2='BackgroundImageFix'
							result='effect1_dropShadow_6031_171893'
						/>
						<feBlend
							mode='normal'
							in='SourceGraphic'
							in2='effect1_dropShadow_6031_171893'
							result='shape'
						/>
					</filter>
				</defs>
			</svg>
		);

	if (variant === 'activity-log')
		return (
			<svg
				width='40'
				height='40'
				viewBox='0 0 40 32'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g filter='url(#filter0_d_4910_123603)'>
					<circle
						cx='20'
						cy='16.5312'
						r='16'
						fill='#E4ECFB'
					/>
					<g opacity='0.4'>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M22.833 10.5312C22.833 10.2551 23.0569 10.0312 23.333 10.0312H25.9997C26.2758 10.0312 26.4997 10.2551 26.4997 10.5312V13.1979C26.4997 13.4741 26.2758 13.6979 25.9997 13.6979C25.7235 13.6979 25.4997 13.4741 25.4997 13.1979V11.0312H23.333C23.0569 11.0312 22.833 10.8074 22.833 10.5312Z'
							fill='#022745'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M26.3536 10.1777C26.5488 10.373 26.5488 10.6895 26.3536 10.8848L22.3536 14.8848C22.1583 15.0801 21.8417 15.0801 21.6464 14.8848C21.4512 14.6895 21.4512 14.373 21.6464 14.1777L25.6464 10.1777C25.8417 9.98243 26.1583 9.98243 26.3536 10.1777Z'
							fill='#022745'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M14 19.3643C14.2761 19.3643 14.5 19.5881 14.5 19.8643V22.0309H16.6667C16.9428 22.0309 17.1667 22.2548 17.1667 22.5309C17.1667 22.8071 16.9428 23.0309 16.6667 23.0309H14C13.7239 23.0309 13.5 22.8071 13.5 22.5309V19.8643C13.5 19.5881 13.7239 19.3643 14 19.3643Z'
							fill='#022745'
						/>
						<path
							fillRule='evenodd'
							clipRule='evenodd'
							d='M18.3536 18.1777C18.5488 18.373 18.5488 18.6895 18.3536 18.8848L14.3536 22.8848C14.1583 23.0801 13.8417 23.0801 13.6464 22.8848C13.4512 22.6895 13.4512 22.373 13.6464 22.1777L17.6464 18.1777C17.8417 17.9824 18.1583 17.9824 18.3536 18.1777Z'
							fill='#022745'
						/>
					</g>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M12.833 16.5309C12.833 12.5748 16.0435 9.36426 19.9997 9.36426C20.4933 9.36426 20.9794 9.41431 21.4444 9.50731C21.7152 9.56146 21.8908 9.82488 21.8366 10.0957C21.7825 10.3664 21.5191 10.542 21.2483 10.4879C20.8466 10.4076 20.4261 10.3643 19.9997 10.3643C16.5958 10.3643 13.833 13.1271 13.833 16.5309C13.833 16.9571 13.8763 17.3704 13.9563 17.7647C14.0113 18.0353 13.8365 18.2993 13.5659 18.3543C13.2953 18.4092 13.0313 18.2344 12.9764 17.9638C12.8831 17.5048 12.833 17.0247 12.833 16.5309Z'
						fill='#022745'
					/>
					<path
						fillRule='evenodd'
						clipRule='evenodd'
						d='M26.4354 14.7071C26.7061 14.6529 26.9696 14.8285 27.0237 15.0993C27.1166 15.5635 27.1668 16.043 27.1668 16.5307C27.1668 20.4868 23.9562 23.6974 20.0001 23.6974C19.5065 23.6974 19.0203 23.6473 18.5554 23.5543C18.2846 23.5002 18.109 23.2367 18.1631 22.966C18.2173 22.6952 18.4807 22.5196 18.7515 22.5737C19.1532 22.6541 19.5737 22.6974 20.0001 22.6974C23.404 22.6974 26.1668 19.9346 26.1668 16.5307C26.1668 16.1117 26.1236 15.6979 26.0431 15.2954C25.989 15.0246 26.1646 14.7612 26.4354 14.7071Z'
						fill='#022745'
					/>
				</g>
				<defs>
					<filter
						id='filter0_d_4910_123603'
						x='0'
						y='0.53125'
						width='40'
						height='40'
						filterUnits='userSpaceOnUse'
						colorInterpolationFilters='sRGB'
					>
						<feFlood
							floodOpacity='0'
							result='BackgroundImageFix'
						/>
						<feColorMatrix
							in='SourceAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
							result='hardAlpha'
						/>
						<feOffset dy='4' />
						<feGaussianBlur stdDeviation='2' />
						<feComposite
							in2='hardAlpha'
							operator='out'
						/>
						<feColorMatrix
							type='matrix'
							values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0'
						/>
						<feBlend
							mode='normal'
							in2='BackgroundImageFix'
							result='effect1_dropShadow_4910_123603'
						/>
						<feBlend
							mode='normal'
							in='SourceGraphic'
							in2='effect1_dropShadow_4910_123603'
							result='shape'
						/>
					</filter>
				</defs>
			</svg>
		);

	if (variant === 'reward-points')
		return (
			<svg
				width='40'
				height='40'
				viewBox='0 0 40 32'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g filter='url(#filter0_d_10830_226069)'>
					<circle
						cx='20'
						cy='16.7227'
						r='16'
						fill='#E4ECFB'
					/>
					<path
						opacity='0.4'
						d='M17.7797 18.0557H14.6663C13.933 18.0557 13.333 18.6557 13.333 19.389V23.389H17.7797V18.0557Z'
						fill='#022745'
					/>
					<path
						d='M20.8868 15.3896H19.1068C18.3734 15.3896 17.7734 15.9896 17.7734 16.723V23.3896H22.2201V16.723C22.2201 15.9896 21.6268 15.3896 20.8868 15.3896Z'
						fill='#022745'
					/>
					<path
						opacity='0.4'
						d='M25.3331 20.0557H22.2197V23.389H26.6664V21.389C26.6664 20.6557 26.0664 20.0557 25.3331 20.0557Z'
						fill='#022745'
					/>
					<path
						d='M22.0061 11.9557C22.2128 11.749 22.2928 11.5023 22.2261 11.289C22.1595 11.0757 21.9528 10.9223 21.6595 10.8757L21.0195 10.769C20.9928 10.7623 20.9328 10.7223 20.9195 10.6956L20.5661 9.98898C20.2995 9.44898 19.6928 9.44898 19.4261 9.98898L19.0728 10.6956C19.0595 10.7223 18.9995 10.7623 18.9728 10.769L18.3328 10.8757C18.0395 10.9223 17.8395 11.0757 17.7661 11.289C17.6995 11.5023 17.7795 11.749 17.9861 11.9557L18.4795 12.4557C18.4995 12.4757 18.5261 12.5557 18.5195 12.5823L18.3795 13.1956C18.2728 13.649 18.4461 13.8556 18.5595 13.9423C18.6728 14.0223 18.9195 14.129 19.3261 13.889L19.9261 13.5357C19.9528 13.5157 20.0395 13.5157 20.0661 13.5357L20.6661 13.889C20.8528 14.0023 21.0061 14.0357 21.1261 14.0357C21.2661 14.0357 21.3661 13.9823 21.4261 13.9423C21.5395 13.8623 21.7128 13.6556 21.6061 13.1956L21.4661 12.5823C21.4595 12.549 21.4795 12.4757 21.5061 12.4557L22.0061 11.9557Z'
						fill='#022745'
					/>
				</g>
				<defs>
					<filter
						id='filter0_d_10830_226069'
						x='0'
						y='0.722656'
						width='40'
						height='40'
						filterUnits='userSpaceOnUse'
						colorInterpolationFilters='sRGB'
					>
						<feFlood
							floodOpacity='0'
							result='BackgroundImageFix'
						/>
						<feColorMatrix
							in='SourceAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
							result='hardAlpha'
						/>
						<feOffset dy='4' />
						<feGaussianBlur stdDeviation='2' />
						<feComposite
							in2='hardAlpha'
							operator='out'
						/>
						<feColorMatrix
							type='matrix'
							values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0'
						/>
						<feBlend
							mode='normal'
							in2='BackgroundImageFix'
							result='effect1_dropShadow_10830_226069'
						/>
						<feBlend
							mode='normal'
							in='SourceGraphic'
							in2='effect1_dropShadow_10830_226069'
							result='shape'
						/>
					</filter>
				</defs>
			</svg>
		);

	if (variant === '2fa')
		return (
			<svg
				width='40'
				height='40'
				viewBox='0 0 40 32'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g filter='url(#filter0_d_11029_54346)'>
					<circle
						cx='20'
						cy='16'
						r='16'
						fill='#E4ECFB'
					/>
					<path
						opacity='0.4'
						d='M19.3062 9.40692L15.6395 10.7802C14.9395 11.0469 14.3662 11.8736 14.3662 12.6269V18.0269C14.3662 18.5669 14.7195 19.2802 15.1529 19.6002L18.8195 22.3403C19.4662 22.8269 20.5262 22.8269 21.1729 22.3403L24.8395 19.6002C25.2729 19.2736 25.6262 18.5669 25.6262 18.0269V12.6269C25.6262 11.8802 25.0529 11.0469 24.3529 10.7869L20.6862 9.41358C20.3129 9.26692 19.6862 9.26692 19.3062 9.40692Z'
						fill='#022745'
					/>
					<path
						d='M20 13.834C20.6437 13.8342 21.166 14.3572 21.166 15.001C21.1659 15.5177 20.8255 15.9524 20.3486 16.1035L20 16.2148L19.6504 16.1035C19.1737 15.9523 18.8332 15.5176 18.833 15.001C18.833 14.3571 19.3561 13.834 20 13.834Z'
						fill='#022745'
						stroke='#022745'
					/>
				</g>
				<defs>
					<filter
						id='filter0_d_11029_54346'
						x='0'
						y='0'
						width='40'
						height='40'
						filterUnits='userSpaceOnUse'
						colorInterpolationFilters='sRGB'
					>
						<feFlood
							floodOpacity='0'
							result='BackgroundImageFix'
						/>
						<feColorMatrix
							in='SourceAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
							result='hardAlpha'
						/>
						<feOffset dy='4' />
						<feGaussianBlur stdDeviation='2' />
						<feComposite
							in2='hardAlpha'
							operator='out'
						/>
						<feColorMatrix
							type='matrix'
							values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0'
						/>
						<feBlend
							mode='normal'
							in2='BackgroundImageFix'
							result='effect1_dropShadow_11029_54346'
						/>
						<feBlend
							mode='normal'
							in='SourceGraphic'
							in2='effect1_dropShadow_11029_54346'
							result='shape'
						/>
					</filter>
				</defs>
			</svg>
		);

	if (variant === 'crypto-settings')
		return (
			<svg
				width='40'
				height='40'
				viewBox='0 0 40 32'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g filter='url(#filter0_d_9777_145232)'>
					<circle
						cx='20'
						cy='16'
						r='16'
						fill='#E4ECFB'
					/>
					<path
						d='M24.3333 16.4297V18.8964C24.3333 20.9764 22.3933 22.663 20 22.663C17.6066 22.663 15.6666 20.9764 15.6666 18.8964V16.4297C15.6666 18.5097 17.6066 19.9964 20 19.9964C22.3933 19.9964 24.3333 18.5097 24.3333 16.4297Z'
						fill='#022745'
					/>
					<path
						opacity='0.4'
						d='M24.3333 13.1016V16.4349C24.3333 18.5149 22.3933 20.0016 20 20.0016C17.6066 20.0016 15.6666 18.5149 15.6666 16.4349V13.1016C15.6666 13.7082 15.8333 14.2682 16.1266 14.7482C16.84 15.9216 18.3066 16.6682 20 16.6682C21.6933 16.6682 23.16 15.9216 23.8733 14.7482C24.1666 14.2682 24.3333 13.7082 24.3333 13.1016Z'
						fill='#022745'
					/>
					<path
						d='M24.3333 13.1026C24.3333 13.7093 24.1666 14.2693 23.8733 14.7493C23.16 15.9226 21.6933 16.6693 20 16.6693C18.3066 16.6693 16.84 15.9226 16.1266 14.7493C15.8333 14.2693 15.6666 13.7093 15.6666 13.1026C15.6666 11.0226 17.6066 9.33594 20 9.33594C21.2 9.33594 22.28 9.75594 23.0666 10.4359C23.8466 11.1226 24.3333 12.0626 24.3333 13.1026Z'
						fill='#022745'
					/>
				</g>
				<defs>
					<filter
						id='filter0_d_9777_145232'
						x='0'
						y='0'
						width='40'
						height='40'
						filterUnits='userSpaceOnUse'
						colorInterpolationFilters='sRGB'
					>
						<feFlood
							floodOpacity='0'
							result='BackgroundImageFix'
						/>
						<feColorMatrix
							in='SourceAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
							result='hardAlpha'
						/>
						<feOffset dy='4' />
						<feGaussianBlur stdDeviation='2' />
						<feComposite
							in2='hardAlpha'
							operator='out'
						/>
						<feColorMatrix
							type='matrix'
							values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0'
						/>
						<feBlend
							mode='normal'
							in2='BackgroundImageFix'
							result='effect1_dropShadow_9777_145232'
						/>
						<feBlend
							mode='normal'
							in='SourceGraphic'
							in2='effect1_dropShadow_9777_145232'
							result='shape'
						/>
					</filter>
				</defs>
			</svg>
		);

	if (variant === 'developer')
		return (
			<svg
				width='40'
				height='40'
				viewBox='0 0 40 32'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g filter='url(#filter0_d_14451_298230)'>
					<circle
						cx='20'
						cy='16'
						r='16'
						fill='#E4ECFB'
					/>
					<path
						opacity='0.4'
						d='M26.6663 13.332V18.792C26.6663 21.2187 25.2197 22.6654 22.793 22.6654H17.2063C14.7797 22.6654 13.333 21.2187 13.333 18.792V13.3387L26.6663 13.332Z'
						fill='#022745'
					/>
					<path
						d='M18 19.8349C17.9266 19.8349 17.8466 19.8149 17.78 19.7816C17.2666 19.5216 16.8266 19.1349 16.5066 18.6549C16.24 18.2549 16.24 17.7416 16.5066 17.3416C16.8266 16.8616 17.2666 16.4749 17.78 16.2216C18.0266 16.0949 18.3266 16.2016 18.4533 16.4482C18.58 16.6949 18.48 16.9949 18.2266 17.1216C17.8666 17.3016 17.56 17.5749 17.34 17.9082C17.3 17.9682 17.3 18.0482 17.34 18.1149C17.56 18.4482 17.8666 18.7216 18.2266 18.9016C18.4733 19.0282 18.5733 19.3282 18.4533 19.5749C18.36 19.7349 18.18 19.8349 18 19.8349Z'
						fill='#022745'
					/>
					<path
						d='M22.1401 19.8336C21.9535 19.8336 21.7801 19.7336 21.6935 19.5603C21.5668 19.3136 21.6668 19.0136 21.9201 18.8869C22.2801 18.7069 22.5868 18.4336 22.8068 18.1003C22.8468 18.0403 22.8468 17.9603 22.8068 17.8936C22.5868 17.5603 22.2801 17.2869 21.9201 17.1069C21.6735 16.9803 21.5735 16.6803 21.6935 16.4336C21.8201 16.1869 22.1201 16.0869 22.3668 16.2069C22.8801 16.4669 23.3201 16.8536 23.6401 17.3336C23.9068 17.7336 23.9068 18.2469 23.6401 18.6469C23.3201 19.1269 22.8801 19.5136 22.3668 19.7669C22.2868 19.8136 22.2135 19.8336 22.1401 19.8336Z'
						fill='#022745'
					/>
					<path
						d='M26.6663 13.2054V13.332L13.333 13.3387V13.2054C13.333 10.7787 14.7797 9.33203 17.2063 9.33203H22.793C25.2197 9.33203 26.6663 10.7787 26.6663 13.2054Z'
						fill='#022745'
					/>
				</g>
				<defs>
					<filter
						id='filter0_d_14451_298230'
						x='0'
						y='0'
						width='40'
						height='40'
						filterUnits='userSpaceOnUse'
						colorInterpolationFilters='sRGB'
					>
						<feFlood
							floodOpacity='0'
							result='BackgroundImageFix'
						/>
						<feColorMatrix
							in='SourceAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
							result='hardAlpha'
						/>
						<feOffset dy='4' />
						<feGaussianBlur stdDeviation='2' />
						<feComposite
							in2='hardAlpha'
							operator='out'
						/>
						<feColorMatrix
							type='matrix'
							values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0'
						/>
						<feBlend
							mode='normal'
							in2='BackgroundImageFix'
							result='effect1_dropShadow_14451_298230'
						/>
						<feBlend
							mode='normal'
							in='SourceGraphic'
							in2='effect1_dropShadow_14451_298230'
							result='shape'
						/>
					</filter>
				</defs>
			</svg>
		);

	if (variant === 'wallet-address')
		return (
			<svg
				width='40'
				height='40'
				viewBox='0 0 40 32'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g filter='url(#filter0_d_268_4350)'>
					<circle
						cx='20'
						cy='16'
						r='16'
						fill='#E4ECFB'
					/>
				</g>
				<path
					opacity='0.4'
					d='M23.652 15.0335C23.372 15.3068 23.212 15.7002 23.252 16.1202C23.312 16.8402 23.972 17.3668 24.692 17.3668H25.9987V18.3335C25.9987 20.3335 24.6654 21.6668 22.6654 21.6668H16.6654C14.6654 21.6668 13.332 20.3335 13.332 18.3335V13.6668C13.332 11.8535 14.4254 10.5868 16.1254 10.3735C16.2987 10.3468 16.4787 10.3335 16.6654 10.3335H22.6654C22.8387 10.3335 23.0054 10.3402 23.1654 10.3668C24.8854 10.5668 25.9987 11.8402 25.9987 13.6668V14.6335H24.612C24.2387 14.6335 23.8987 14.7802 23.652 15.0335Z'
					fill='#022745'
				/>
				<path
					d='M26.6655 15.3133V16.6866C26.6655 17.0533 26.3722 17.3533 25.9988 17.3666H24.6922C23.9722 17.3666 23.3122 16.84 23.2522 16.12C23.2122 15.7 23.3722 15.3066 23.6522 15.0333C23.8988 14.78 24.2388 14.6333 24.6122 14.6333H25.9988C26.3722 14.6466 26.6655 14.9466 26.6655 15.3133Z'
					fill='#022745'
				/>
				<defs>
					<filter
						id='filter0_d_268_4350'
						x='0'
						y='0'
						width='40'
						height='40'
						filterUnits='userSpaceOnUse'
						colorInterpolationFilters='sRGB'
					>
						<feFlood
							floodOpacity='0'
							result='BackgroundImageFix'
						/>
						<feColorMatrix
							in='SourceAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
							result='hardAlpha'
						/>
						<feOffset dy='4' />
						<feGaussianBlur stdDeviation='2' />
						<feComposite
							in2='hardAlpha'
							operator='out'
						/>
						<feColorMatrix
							type='matrix'
							values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0'
						/>
						<feBlend
							mode='normal'
							in2='BackgroundImageFix'
							result='effect1_dropShadow_268_4350'
						/>
						<feBlend
							mode='normal'
							in='SourceGraphic'
							in2='effect1_dropShadow_268_4350'
							result='shape'
						/>
					</filter>
				</defs>
			</svg>
		);

	if (variant === 'transactions')
		return (
			<svg
				width='40'
				height='40'
				viewBox='0 0 40 32'
				fill='none'
				xmlns='http://www.w3.org/2000/svg'
				{...rest}
			>
				<g filter='url(#filter0_d_268_4351)'>
					<circle
						cx='20'
						cy='16'
						r='16'
						fill='#E4ECFB'
					/>
				</g>
				<path
					opacity='0.4'
					d='M16.4881 21.1335C17.0348 20.5468 17.8681 20.5935 18.3481 21.2335L19.0215 22.1335C19.5615 22.8468 20.4348 22.8468 20.9748 22.1335L21.6481 21.2335C22.1281 20.5935 22.9615 20.5468 23.5081 21.1335C24.6948 22.4002 25.6615 21.9802 25.6615 20.2068V12.6935C25.6615 10.0068 25.0348 9.3335 22.5148 9.3335H17.4748C14.9548 9.3335 14.3281 10.0068 14.3281 12.6935V20.2002C14.3348 21.9802 15.3081 22.3935 16.4881 21.1335Z'
					fill='#022745'
				/>
				<path
					d='M21.8346 15.1665H18.168C17.8946 15.1665 17.668 14.9398 17.668 14.6665C17.668 14.3932 17.8946 14.1665 18.168 14.1665H21.8346C22.108 14.1665 22.3346 14.3932 22.3346 14.6665C22.3346 14.9398 22.108 15.1665 21.8346 15.1665Z'
					fill='#022745'
				/>
				<defs>
					<filter
						id='filter0_d_268_4351'
						x='0'
						y='0'
						width='40'
						height='40'
						filterUnits='userSpaceOnUse'
						colorInterpolationFilters='sRGB'
					>
						<feFlood
							floodOpacity='0'
							result='BackgroundImageFix'
						/>
						<feColorMatrix
							in='SourceAlpha'
							type='matrix'
							values='0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0'
							result='hardAlpha'
						/>
						<feOffset dy='4' />
						<feGaussianBlur stdDeviation='2' />
						<feComposite
							in2='hardAlpha'
							operator='out'
						/>
						<feColorMatrix
							type='matrix'
							values='0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.2 0'
						/>
						<feBlend
							mode='normal'
							in2='BackgroundImageFix'
							result='effect1_dropShadow_268_4351'
						/>
						<feBlend
							mode='normal'
							in='SourceGraphic'
							in2='effect1_dropShadow_268_4351'
							result='shape'
						/>
					</filter>
				</defs>
			</svg>
		);

	return <></>;
};
